<div class="container" id="faq">
    <div class="section-title">
        <h2>Häufige Fragen</h2>
        <div class="bar"></div>
        <p>Du hast Fragen zur Anmeldung, Theorie oder Praxis? Hier findest du Antworten auf die häufigsten Fragen rund um unsere Fahrschule.</p>
    </div>

    <div class="row align-items-center">
        <div class="col-lg-6 col-md-12">
            <div class="faq-accordion-content">
                <div class="accordion" id="faqAccordion">
                    <!-- Frage 1 -->
                    <div class="card">
                        <div class="card-header" id="headingOne">
                            <button type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                Wie melde ich mich bei Tommys Fahrschule an?
                                <i class="fa fa-chevron-down"></i>
                            </button>
                        </div>
                        <div id="collapseOne" class="collapse show" data-bs-parent="#faqAccordion">
                            <div class="card-body">
                                <p>Du kannst dich direkt über unser Kontaktformular anmelden oder persönlich zu unseren Öffnungszeiten in der Fahrschule vorbeikommen. Wir beraten dich gern unverbindlich.</p>
                            </div>
                        </div>
                    </div>

                    <!-- Frage 2 -->
                    <div class="card">
                        <div class="card-header" id="headingTwo">
                            <button class="collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                Wie lange dauert der Theorieunterricht?
                                <i class="fa fa-chevron-down"></i>
                            </button>
                        </div>
                        <div id="collapseTwo" class="collapse" data-bs-parent="#faqAccordion">
                            <div class="card-body">
                                <p>Unsere Theorie kann in nur 7 Tagen abgeschlossen werden! Du besuchst täglich Unterrichtseinheiten und bist in kürzester Zeit bereit für die Prüfung.</p>
                            </div>
                        </div>
                    </div>

                    <!-- Frage 3 -->
                    <div class="card">
                        <div class="card-header" id="headingThree">
                            <button class="collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                Muss ich lange auf Fahrstunden warten?
                                <i class="fa fa-chevron-down"></i>
                            </button>
                        </div>
                        <div id="collapseThree" class="collapse" data-bs-parent="#faqAccordion">
                            <div class="card-body">
                                <p>Nein, bei uns gibt es keine langen Wartezeiten! Durch unser gut organisiertes Team kannst du zeitnah Fahrstunden vereinbaren – ganz flexibel nach deinem Zeitplan.</p>
                            </div>
                        </div>
                    </div>

                    <!-- Frage 4 -->
                    <div class="card">
                        <div class="card-header" id="headingFour">
                            <button class="collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                Welche Unterlagen brauche ich zur Anmeldung?
                                <i class="fa fa-chevron-down"></i>
                            </button>
                        </div>
                        <div id="collapseFour" class="collapse" data-bs-parent="#faqAccordion">
                            <div class="card-body">
                                <p>Für die Anmeldung brauchst du ein aktuelles Passbild, einen Sehtest, einen Nachweis über den Erste-Hilfe-Kurs und deinen Ausweis. Wir helfen dir gern bei der Zusammenstellung.</p>
                            </div>
                        </div>
                    </div>

                    <!-- Frage 5 -->
                    <div class="card">
                        <div class="card-header" id="headingFive">
                            <button class="collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                Was kostet der Führerschein bei euch?
                                <i class="fa fa-chevron-down"></i>
                            </button>
                        </div>
                        <div id="collapseFive" class="collapse" data-bs-parent="#faqAccordion">
                            <div class="card-body">
                                <p>Alle Preise findest du auf unserer Website unter „Preise“. Die Gesamtkosten hängen von deiner individuellen Fahrpraxis ab – sprich uns einfach an für eine persönliche Einschätzung.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Bild -->
        <div class="col-lg-6 col-md-12">
            <div class="faq-image">
                <img src="assets/img/faq-mobile.png" alt="image">
            </div>
        </div>
    </div>
</div>
